import { Chip } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { TradeAgreementUsage } from 'quotes/enums';
import { ITradeAgreement } from 'quotes/types';
import { Color, Variant } from 'theme/enums';

import {
  getTradeAgreementUsage,
  ITradeAgreementUsageContext,
  tradeAgreementUsageLabelKeys,
} from '../../../utils';

interface IInUseStatusCellParams
  extends ICellRendererParams<ITradeAgreement>,
    Partial<ITradeAgreementUsageContext> {}

// Green is the line's cost, blue the default while something else is picked, grey the rest.
const usageColors: Record<TradeAgreementUsage, Color> = {
  [TradeAgreementUsage.DEFAULT]: Color.PRIMARY,
  [TradeAgreementUsage.DEFAULT_IN_USE]: Color.SUCCESS,
  [TradeAgreementUsage.IN_USE]: Color.SUCCESS,
  [TradeAgreementUsage.NOT_IN_USE]: Color.NEUTRAL,
};

export const InUseStatusCell = ({
  data,
  defaultRowId,
  heldRowId,
  isDefaultInUse,
}: IInUseStatusCellParams) => {
  if (!data) {
    return null;
  }

  const usage = getTradeAgreementUsage(data, { defaultRowId, heldRowId, isDefaultInUse });

  // Never cut: Joy ellipsizes a chip narrower than its text, so the column fits the longest.
  return (
    <Chip
      color={usageColors[usage]}
      variant={Variant.SOFT}
      sx={{ minWidth: 'max-content' }}
      slotProps={{ label: { sx: { overflow: 'visible' } } }}
    >
      {t(tradeAgreementUsageLabelKeys[usage])}
    </Chip>
  );
};
